<template>
  <el-dialog class="invoice-info" title="开票详情" width="500px" :visible.sync="visible">
    <div class="invoice-info-block">
      <div class="block-item">
        <span class="block-item_label">物流单号</span>
        <span class="block-item_value">{{ invoice.trickNo }} </span>
      </div>
      <div class="block-item">
        <span class="block-item_label">物流备注</span>
        <span class="block-item_value">{{ invoice.trickRemark }} </span>
      </div>
      <div class="block-item">
        <span class="block-item_label">发票</span>
        <div class="block-item_images" v-if="invoice.fileEntities">
          <img v-for="(item, index) in invoice.fileEntities" :key="index" :src="`/${item.filePath}`" />
        </div>
      </div>
    </div>

    <span slot="footer" class="invoice-footer">
      <el-button size="small" @click="handleConfirm">好的</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
      invoice: {},
    };
  },
  methods: {
    show(data) {
      this.invoice = data;
      console.log('this.invoice', this.invoice);
      this.visible = true;
    },
    handleConfirm() {
      this.visible = !this.visible;
    },
  },
};
</script>

<style lang="less" scoped>
.invoice-info {
  font-size: 14px;

  .block-item {
    display: flex;
    flex-direction: row;
    margin-bottom: 10px;
    .block-item_label {
      width: 70px;
      text-align: right;
      margin-right: 10px;
    }
    .block-item_label:after {
      content: ':';
      padding-left: 3px;
    }
    .block-item_images {
      > img {
        width: 90px;
        height: 90px;
        border-radius: 4px;
        margin: 0px 10px 10px 0px;
      }
    }
  }
  .invoice-info-block {
  }

  /deep/ .el-dialog__body {
    padding: 0px 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/invoice/components/invoiceInfo.vue